(function () {
  var cookieBanner = document.querySelector("[data-atlas-cookie-banner]");

  if (cookieBanner) {
    var cookieChoice = window.localStorage && localStorage.getItem("atlas_cookie_choice");

    if (cookieChoice) cookieBanner.classList.add("is-hidden");

    cookieBanner.querySelectorAll("[data-atlas-cookie-choice]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (window.localStorage) localStorage.setItem("atlas_cookie_choice", button.dataset.atlasCookieChoice);
        cookieBanner.classList.add("is-hidden");
      });
    });
  }

  var page = document.querySelector(".atlas-page");
  if (!page) return;

  var floatingNav = page.querySelector(".atlas-floating-nav");
  var intro = page.querySelector(".atlas-intro");
  var navLinks = Array.prototype.slice.call(page.querySelectorAll("[data-atlas-scroll]"));
  var contactForm = page.querySelector(".atlas-form");
  var revealItems = Array.prototype.slice.call(page.querySelectorAll(".atlas-reveal"));
  var onboardingPage = page.matches("[data-onboarding-page]");
  var depositPage = page.matches("[data-deposit-page]");
  var workShowcasePage = page.matches("[data-work-showcase]");
  var progress = page.querySelector("[data-atlas-progress]");
  var progressFill = page.querySelector("[data-atlas-progress-fill]");

  function scrollToTarget(selector) {
    var target = document.querySelector(selector);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  if (intro) {
    window.setTimeout(function () {
      if (intro && intro.parentNode) intro.parentNode.removeChild(intro);
    }, 3300);
  }

  navLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      var target = link.getAttribute("href") || link.dataset.atlasScroll;
      if (target && target.charAt(0) === "#") {
        event.preventDefault();
        scrollToTarget(target);
      }
    });
  });

  window.addEventListener("scroll", function () {
    if (!floatingNav) return;
    floatingNav.classList.toggle("is-visible", window.scrollY > 300);
  }, { passive: true });

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });

    revealItems.forEach(function (item) { observer.observe(item); });
  } else {
    revealItems.forEach(function (item) { item.classList.add("is-visible"); });
  }

  if (workShowcasePage) {
    var callouts = Array.prototype.slice.call(page.querySelectorAll("[data-work-callout]"));
    if ("IntersectionObserver" in window) {
      var calloutObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      }, { threshold: 0.2 });
      callouts.forEach(function (callout) { calloutObserver.observe(callout); });
    } else {
      callouts.forEach(function (callout) { callout.classList.add("is-visible"); });
    }
  }

  page.querySelectorAll("[data-plan-link]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      var href = link.getAttribute("href");
      if (!href || href === "#contact") {
        event.preventDefault();
        scrollToTarget("#contact");
        var message = page.querySelector("#AtlasContactMessage");
        if (message) {
          message.value = "I am interested in the " + link.dataset.plan + " plan with the " + link.dataset.deposit + " deposit.";
          message.focus();
        }
      }
    });
  });

  function getPlanDetails() {
    var params = new URLSearchParams(window.location.search);
    var plan = (params.get("plan") || "").toLowerCase();

    if (plan === "professional") {
      return {
        key: "professional",
        name: "Professional",
        deposit: "$500 deposit",
        checkout: page.dataset.professionalCheckout || ""
      };
    }

    if (plan === "premium") {
      return {
        key: "premium",
        name: "Premium",
        deposit: "Premium deposit",
        checkout: page.dataset.premiumCheckout || ""
      };
    }

    return {
      key: "starter",
      name: "Starter",
      deposit: "$250 deposit",
      checkout: page.dataset.starterCheckout || ""
    };
  }

  function setProgress(percent, activeStep) {
    if (!progress || !progressFill) return;
    progressFill.style.width = Math.max(0, Math.min(100, percent)) + "%";
    progress.querySelectorAll("[data-progress-step]").forEach(function (step) {
      step.classList.toggle("is-active", step.dataset.progressStep === activeStep);
    });
  }

  function showPaymentStep(formSubmitted) {
    var paymentStep = page.querySelector("[data-payment-step]");
    var paymentLink = page.querySelector("[data-payment-link]");
    var paymentCopy = page.querySelector("[data-payment-copy]");
    var note = contactForm && contactForm.querySelector(".atlas-form-note");
    var planDetails = getPlanDetails();
    var depositPageUrl = page.dataset.depositPage || "/pages/deposit";
    var depositUrl = depositPageUrl + (depositPageUrl.indexOf("?") === -1 ? "?" : "&") + "plan=" + encodeURIComponent(planDetails.key);

    setProgress(100, "payment");

    if (paymentStep) paymentStep.hidden = false;
    if (paymentLink) paymentLink.href = depositUrl;
    if (paymentCopy) {
      paymentCopy.textContent = "Your onboarding details are saved. We are taking you to the Atlas deposit page to review your " + planDetails.deposit + ".";
    }

    if (note) {
      note.textContent = formSubmitted ? "Details saved. Opening deposit page..." : "Opening deposit page...";
      note.classList.add("is-visible");
      note.classList.remove("is-error");
    }

    if (paymentStep) paymentStep.scrollIntoView({ behavior: "smooth", block: "center" });
    window.setTimeout(function () {
      window.location.href = depositUrl;
    }, formSubmitted ? 900 : 1200);
  }

  function saveOnboardingDetails() {
    if (!window.localStorage || !contactForm || !window.FormData) return;
    var details = {};
    var formData = new FormData(contactForm);
    formData.forEach(function (value, key) {
      details[key] = value;
    });
    details.savedAt = new Date().toISOString();
    localStorage.setItem("atlas_onboarding_details", JSON.stringify(details));
  }

  if (onboardingPage) {
    var selectedPlan = getPlanDetails();
    var selectedPlanInput = page.querySelector("[data-selected-plan-input]");
    var selectedPlanName = page.querySelector("[data-selected-plan-name]");
    var selectedPlanDeposit = page.querySelector("[data-selected-plan-deposit]");

    if (selectedPlanInput) selectedPlanInput.value = selectedPlan.name + " - " + selectedPlan.deposit;
    if (selectedPlanName) selectedPlanName.textContent = selectedPlan.name;
    if (selectedPlanDeposit) selectedPlanDeposit.textContent = selectedPlan.deposit + " will be collected securely through Stripe after onboarding.";

    setProgress(34, "onboarding");

    window.addEventListener("scroll", function () {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var scrolled = scrollable > 0 ? window.scrollY / scrollable : 0;
      setProgress(34 + scrolled * 33, "onboarding");
    }, { passive: true });
  }

  if (depositPage) {
    var depositDetails = getPlanDetails();
    var depositPlan = page.querySelector("[data-deposit-plan]");
    var depositAmount = page.querySelector("[data-deposit-amount]");
    var depositCopy = page.querySelector("[data-deposit-copy]");
    var depositLink = page.querySelector("[data-deposit-link]");
    var depositEdit = page.querySelector("[data-deposit-edit]");

    if (depositPlan) depositPlan.textContent = depositDetails.name;
    if (depositAmount) depositAmount.textContent = depositDetails.deposit;
    if (depositCopy) {
      depositCopy.textContent = "This secure deposit reserves your " + depositDetails.name + " project and starts the build process.";
    }
    if (depositLink && depositDetails.checkout) {
      depositLink.href = depositDetails.checkout;
    } else if (depositLink) {
      depositLink.href = "/pages/onboarding?plan=" + encodeURIComponent(depositDetails.key);
      depositLink.textContent = "Payment Link Missing";
      depositLink.setAttribute("aria-disabled", "true");
    }
    if (depositEdit) {
      depositEdit.href = "/pages/onboarding?plan=" + encodeURIComponent(depositDetails.key);
    }
  }

  if (contactForm) {
    contactForm.addEventListener("submit", function (event) {
      var note = contactForm.querySelector(".atlas-form-note");
      var submitButton = contactForm.querySelector("button[type='submit']");
      var action = contactForm.getAttribute("action") || window.location.pathname;
      var isOnboardingForm = onboardingPage && contactForm.closest("[data-onboarding-page]");

      if (isOnboardingForm) {
        event.preventDefault();
        if (contactForm.checkValidity && !contactForm.checkValidity()) {
          contactForm.reportValidity();
          return;
        }
        if (note) {
          note.textContent = "";
          note.classList.remove("is-visible", "is-error");
        }
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add("is-loading");
        }
        saveOnboardingDetails();
        showPaymentStep(true);
        return;
      }

      if (!window.fetch || !window.FormData) return;

      event.preventDefault();
      if (note) {
        note.textContent = "";
        note.classList.remove("is-visible", "is-error");
      }
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add("is-loading");
      }

      fetch(action, {
        method: "POST",
        body: new FormData(contactForm),
        credentials: "same-origin"
      }).then(function (response) {
        if (!response.ok) throw new Error("Form submission failed");
        contactForm.reset();
        if (isOnboardingForm) {
          showPaymentStep(true);
          return;
        }
        if (note) {
          note.textContent = "Thank you! Your project details were sent. We will be in touch soon.";
          note.classList.add("is-visible");
        }
      }).catch(function () {
        if (isOnboardingForm) {
          showPaymentStep(false);
          return;
        }
        if (note) {
          note.textContent = "Something went wrong. Please try again or email atlascreativeweb@gmail.com.";
          note.classList.add("is-visible", "is-error");
        }
      }).finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove("is-loading");
        }
      });
    });
  }
})();
